/** @jsx jsx */
import { Box, Container, Flex, Grid, Heading, jsx } from 'theme-ui'
import Slider from 'react-slick'
import PackAwardsCard from '~/components/Pack/Card/Awards'
import { SliderWrapper } from './styles'

const AwardCarouselSection = ({ cta, description, packs, title, isTrade }) => {
  const settings = {
    arrows: false,
    centerPadding: '0',
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <Box bg="backgroundLight" pt={[7, null, 9]} pb={[8, null, 10]}>
      <Container>
        <Grid columns={[null, 12]}>
          <Box
            mb={5}
            sx={{
              gridColumn: [null, '3 / 11', null, '4 / 10'],
              textAlign: 'center',
            }}
          >
            <Heading as="h2" variant="title2" mb={[3, 4]}>
              {title}
            </Heading>
            {description && (
              <Box
                sx={{
                  variant: 'text.body1',
                  'p:first-of-type': { mt: 0 },
                  'p:last-of-type': { mb: 0 },
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
        </Grid>
        <Box mx={'-12px'} sx={{ width: 'calc(100% + 24px)' }}>
          <SliderWrapper>
            <Slider {...settings}>
              {packs.map((pack, index) => (
                <Flex
                  key={`awards-pack-${pack.id}`}
                  px={'12px'}
                  sx={{
                    height: '100%',
                    '&:focus:not(:focus-visible)': { outline: 'none' },
                  }}
                >
                  <PackAwardsCard pack={pack} isTrade={isTrade} />
                </Flex>
              ))}
            </Slider>
          </SliderWrapper>
        </Box>
        {cta && (
          <Box mt={[4, null, 6]} sx={{ textAlign: 'center' }}>
            {cta}
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default AwardCarouselSection
